import React from "react";
import styled from "@emotion/styled";

import { CategoryList } from "../../utils/categoryList";
import { CategoryCard } from "../card/categoryCard";

export const CategoryWrapper = () => {
  return (
    <SWrapper>
      {CategoryList.map(({ tileType, href, txt, img }) => {
        return (
          <CategoryCard
            tileType={tileType}
            href={href}
            txt={txt}
            img={img}
            key={tileType}
          />
        );
      })}
    </SWrapper>
  );
};

const SWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas:
    "category001 category001 category002"
    "category003 category003 category002"
    "category004 category005 category006";
  gap: 8px;

  /* ------------ */
  /* TB */
  @media screen and (max-width: 1023px) {
  }

  /* ------------ */
  /* SP */
  @media screen and (max-width: 599px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "category001"
      "category002"
      "category003"
      "category004"
      "category005"
      "category006";
  }
`;
